var components
try {
  components = {
    uIcon: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-icon/u-icon" */ "@/uni_modules/uview-ui/components/u-icon/u-icon.vue"
      )
    },
    uLineProgress: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-line-progress/u-line-progress" */ "@/uni_modules/uview-ui/components/u-line-progress/u-line-progress.vue"
      )
    },
    uEmpty: function () {
      return import(
        /* webpackChunkName: "uni_modules/uview-ui/components/u-empty/u-empty" */ "@/uni_modules/uview-ui/components/u-empty/u-empty.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 =
    _vm.courseList && _vm.courseList.length > 0 && _vm.detail.resourceType == 1
  var g1 = _vm.courseList && _vm.courseList.length > 0
  var l1 = g1
    ? _vm.__map(_vm.courseList, function (item, index) {
        var $orig = _vm.__get_orig(item)
        var l0 = _vm.__map(item.studentStudyPeriodVOList, function (i, idx) {
          var $orig = _vm.__get_orig(i)
          var m0 = i.resourceType == 1 ? _vm.secondsToHms(i.period) : null
          return {
            $orig: $orig,
            m0: m0,
          }
        })
        return {
          $orig: $orig,
          l0: l0,
        }
      })
    : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        g1: g1,
        l1: l1,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }